module.exports = __webpack_public_path__ + "img/icon_shiyong.6c6cbf57.png";